import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/Articles3.png';

const Article3 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          5 Tips for Parents to Find the Best Home Tutors in Vadodara
        </h2>

        <div className="rsh-published-badge">
          Published on: 03 January 2026
        </div>

        <img
          src={blog1}
          alt="Best Home Tutors in Vadodara"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Choosing the right home tutor for your child in Vadodara requires
            careful planning and informed decision-making. With increasing
            academic competition, parents are actively seeking qualified home
            tutors who can provide personalized guidance and consistent academic
            support.
          </p>

          <p>
            Vadodara is home to many reputed schools following CBSE, ICSE, and
            Gujarat Board syllabi. However, classroom teaching alone may not be
            sufficient for every student. Home tuition bridges this gap by
            offering focused learning tailored to the student’s pace and needs.
          </p>

          {/* TIP 1 */}
          <div className="info-box">
            <h3>Tip 1: Clearly Identify Your Child’s Academic Needs</h3>
            <p>
              Before hiring a home tutor, parents should assess their child’s
              strengths and weaknesses. Understanding the exact requirement
              helps in selecting the right tutor.
            </p>
            <ul>
              <li>Is the child struggling with specific subjects?</li>
              <li>Does the child need exam-oriented preparation?</li>
              <li>Is concept clarity or homework support required?</li>
              <li>Is competitive exam coaching needed?</li>
            </ul>
          </div>

          {/* TIP 2 */}
          <div className="info-box">
            <h3>Tip 2: Check Tutor Qualifications and Teaching Experience</h3>
            <p>
              A tutor’s educational background and teaching experience play a
              crucial role in academic improvement.
            </p>
            <ul>
              <li>Strong subject expertise and academic credentials</li>
              <li>Experience teaching CBSE, ICSE, or Gujarat Board students</li>
              <li>Proven track record with school students in Vadodara</li>
              <li>Positive feedback from parents</li>
            </ul>
          </div>

          {/* TIP 3 */}
          <div className="info-box">
            <h3>Tip 3: Evaluate Teaching Style and Student Compatibility</h3>
            <p>
              Every child has a unique learning style. Some students prefer
              visual explanations, while others benefit from step-by-step
              problem-solving.
            </p>
            <p>
              A demo or trial class helps parents determine whether the tutor’s
              teaching approach matches the child’s learning preferences.
            </p>
          </div>

          {/* TIP 4 */}
          <div className="info-box">
            <h3>Tip 4: Decide Between Home Tuition and Coaching Institutes</h3>
            <p>
              Parents often compare home tuition with coaching institutes.
              Understanding the differences helps in making the right choice.
            </p>
          </div>

          {/* TABLE */}
          <h3 className="table-title">
            Home Tuition vs Coaching Institutes in Vadodara
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Factor</th>
                  <th>Home Tuition</th>
                  <th>Coaching Institute</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Personal Attention</td>
                  <td>High (1-on-1)</td>
                  <td>Limited (Group batches)</td>
                </tr>
                <tr>
                  <td>Learning Pace</td>
                  <td>Customized</td>
                  <td>Fixed</td>
                </tr>
                <tr>
                  <td>Convenience</td>
                  <td>At home</td>
                  <td>Travel required</td>
                </tr>
                <tr>
                  <td>Parent Involvement</td>
                  <td>High</td>
                  <td>Low</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* TIP 5 */}
          <div className="info-box">
            <h3>Tip 5: Discuss Fees, Schedule, and Progress Tracking</h3>
            <p>
              Clear communication regarding tuition fees, class timings, and
              performance evaluation avoids misunderstandings later.
            </p>
            <ul>
              <li>Confirm monthly fees and payment terms</li>
              <li>Agree on class frequency and duration</li>
              <li>Ask for regular feedback and progress updates</li>
            </ul>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Thoughts</h3>
            <p>
              Finding the best home tutor in Vadodara is not just about academic
              qualifications but also about compatibility, commitment, and
              teaching quality. By following these five tips, parents can make
              informed decisions and ensure their child’s long-term academic
              success.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article3;